import { useCallback, useEffect } from "react";
import { CreateAlertFormValues } from "../types";

interface UseAlertCreationTemplateCustomizationParams {
	values: CreateAlertFormValues;
	setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
	templateMessages: Record<string, { title: string; description: string; icon: any }>;
}

export function useAlertCreationTemplateCustomization({
	values,
	setFieldValue,
	templateMessages,
}: UseAlertCreationTemplateCustomizationParams) {
	const updateTemplateValues = useCallback(
		(templateType: string) => {
			if (templateType && templateMessages[templateType]) {
				const template = templateMessages[templateType];
				setFieldValue("customTitle", template.title, false);
				setFieldValue("customDescription", template.description, false);
			}
		},
		[templateMessages, setFieldValue]
	);

	useEffect(() => {
		if (values.templateType && values.templateType !== "no_category" && !values.customTitle && templateMessages[values.templateType]) {
			updateTemplateValues(values.templateType);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const setAlertTitle = useCallback(
		(newTitle: string) => setFieldValue("customTitle", newTitle, false),
		[setFieldValue]
	);

	const setAlertDescription = useCallback(
		(newDescription: string) => setFieldValue("customDescription", newDescription, false),
		[setFieldValue]
	);

	return {
		alertTitle: values.customTitle || "",
		alertDescription: values.customDescription || "",
		setAlertTitle,
		setAlertDescription,
		updateTemplateValues,
	};
}
